export default [
  {
    path: '/document',
    component: DefaultLayout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "DocumentTable" */ './pages/DocumentTable.vue'),
        meta: {
          title: '调用列表',
        },
      },
      {
        path: 'preview',
        component: () => import(/* webpackChunkName: "DocumentPreview" */ './pages/DocumentPreview.vue'),
        meta: {
          title: '文档解析',
        },
      },
      {
        path: ':id/preview',
        component: () => import(/* webpackChunkName: "DocumentPreview" */ './pages/DocumentPreview.vue'),
        meta: {
          title: '文档解析',
        },
      },
      {
        path: 'try',
        component: () => import(/* webpackChunkName: "DocumentPreview" */ './pages/GuestDocumentPreview.vue'),
        meta: {
          title: '文档解析',
          auth: false,
        },
      },
    ],
  },
]
